import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '@ztechapps/common.contract'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class RevokeManifestDocumentLinksArgs extends ActionArgs {
  @Field(() => ID)
  ticketId: string
}

export interface IRevokeManifestDocumentLinks extends IAction<number, RevokeManifestDocumentLinksArgs> {}
